import { lazy } from "react";

const PublicBusinessCardPage = lazy(
  () => import("@pages/public-business-card/ui/PublicBusinessCardPage"),
);
const ResetPage = lazy(() => import("@pages/reset/ResetPage"));
const PackagesClient = lazy(
  () => import("@pages/dashboard/PackagesClient/PackagesClient"),
);
const NotFound = lazy(() => import("@pages/not-found/NotFound"));
const LandingPage = lazy(() => import("@pages/landing/ui/LandingPage"));
const InstagramCallbackPage = lazy(
  () => import("@pages/instagram-callback/ui/InstagramCallbackPage"),
);

// Old landing design, kept reachable at /old for text/copy comparison against the new one.
const LandingOldLayout = lazy(() => import("@pages/landing-old/ui/LandingLayout"));
const LandingOldHome = lazy(() => import("@pages/landing-old/Home/Home"));

export const miscRoutes = [
  { path: "/", element: <LandingPage /> },
  {
    path: "/old",
    element: <LandingOldLayout />,
    children: [{ index: true, element: <LandingOldHome /> }],
  },
  { path: "business-cards/:id?", element: <PublicBusinessCardPage /> },
  { path: "packages", element: <PackagesClient /> },
  { path: "instagram/callback", element: <InstagramCallbackPage /> },
  { path: "/reset", element: <ResetPage /> },
  { path: "*", element: <NotFound /> },
];
